import { mergeStyles } from '@fluentui/react';
import * as React from 'react';
import { captureContentUpdate } from '../../../../web/utils/oneDsUtil';
import { sanitizeHTML } from '../../../utilities';
import { ICommonThemedStyles, getCommonClassNames, getCommonStyles, getCommonThemedClassNames } from '../styles/commonStyles';

import { IStyledComponent } from '../styles/themesUI';
import { getString } from '../../../../web/utils/stringLoader';

interface ThirdPartyCookiesDisabledState {
    urlToRedirectUser: string;
    areaName: string;
}

async function logContentUpdate(areaName: string) {
    const overrideTags = {
        content: { areaName: areaName },
        behavior: 160,
    };

    captureContentUpdate(overrideTags);
}

type ThirdPartyCookiesDisabledProps = IStyledComponent<ICommonThemedStyles>;
const commonClassNames = getCommonClassNames(getCommonStyles());

export class ThirdPartyCookiesDisabled extends React.Component<ThirdPartyCookiesDisabledProps, ThirdPartyCookiesDisabledState> {
    public constructor(props: ThirdPartyCookiesDisabledProps) {
        super(props);
        const areaName = 'thirdPartyCookiesDisabledSection';
        this.state = { urlToRedirectUser: `https://support.microsoft.com/home/contact?ContactUsExperienceEntryPointAssetId=${areaName}`, areaName: areaName };
        logContentUpdate(this.state.areaName);
    }
    public render() {
        const commonThemedClassNames = getCommonThemedClassNames(
            this.props.styles,
            { theme: this.props.theme }
        );

        const fontColor = commonThemedClassNames.textColor;
        const marginLeft = commonClassNames.marginLeft20;
        const marginTop = commonClassNames.marginTop8;
        const fontClassName = commonClassNames.fontSizeMedium;
        const disabledHtmlMessage = getString('result_thirdPartyCookiesDisabledMessage')
            .replace('{0}', `<a href=${this.state.urlToRedirectUser} data-bi-formnm="maxFunnel" data-bi-area=${this.state.areaName} data-bi-name="thirdPartyCookiesDisabledLink" target="_blank">`)
            .replace('{1}', '</a>');

        const className = mergeStyles(fontColor, marginLeft, marginTop, fontClassName);
        return (
            // eslint-disable-next-line react/no-danger
            <div className={className} id="thirdPartyCookieMessage" dangerouslySetInnerHTML={sanitizeHTML(disabledHtmlMessage, ['target'])} />
        );
    }
}
